module.exports = __webpack_public_path__ + "static/img/index3.20f6752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/BY_S07/index3.png
// module id = ohO4
// module chunks = 0